import type { EnrollmentShape, EnrollmentStep } from '../types';
import type { UseEnrollmentResult } from '../useEnrollment';

export type LandingBody = Extract<
  NonNullable<UseEnrollmentResult['body']>,
  { steps: EnrollmentStep[] }
>;

/** What the enrollment landing renders. `landing` without a body holds the
 *  landing's loading state; `loading` and `forward` replace the landing for a
 *  protocol that hides it. */
export type LandingView =
  | { kind: 'error' }
  | { kind: 'closed' }
  | { kind: 'complete'; shape: EnrollmentShape }
  | { kind: 'loading' }
  | { kind: 'forward'; route: string }
  | { kind: 'landing'; body: LandingBody | undefined };

export type LandingViewInput = Pick<
  UseEnrollmentResult,
  | 'body'
  | 'isError'
  | 'isWindowClosed'
  | 'ctaRoute'
  | 'skipsLanding'
  | 'isSettling'
>;

/** Maps the enrollment seam to the landing's view; the first match wins. */
export const resolveLandingView = ({
  body,
  isError,
  isWindowClosed,
  ctaRoute,
  skipsLanding,
  isSettling,
}: LandingViewInput): LandingView => {
  if (isError) return { kind: 'error' };
  if (isWindowClosed) return { kind: 'closed' };
  if (body?.phase === 'complete') {
    return { kind: 'complete', shape: body.shape };
  }
  if (skipsLanding) {
    if (isSettling) return { kind: 'loading' };
    if (ctaRoute !== undefined) return { kind: 'forward', route: ctaRoute };
  }
  return { kind: 'landing', body };
};
